import { render, staticRenderFns } from "./RatingAdvancedProps.vue?vue&type=template&id=5898eb42"
import script from "./RatingAdvancedProps.vue?vue&type=script&lang=js"
export * from "./RatingAdvancedProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports